import type React from 'react';

import { usePayments } from '../../../context/PaymentsProvider';
import { checkAdvNationMapping } from '../../../utils/mapCurrencyNation';

import OnlineBankingComponent from './OnlineBankingComponent';

const OnlineBanking: React.FC = () => {
  const { advertiserNation, currency, onlineBanking } = usePayments();

  if (!onlineBanking) {
    return <></>;
  }

  const { handleOnChangeOnlineBanking } = onlineBanking;

  const country = checkAdvNationMapping(advertiserNation, currency);

  return (
    <OnlineBankingComponent
      {...{
        handleOnChangeOnlineBanking,
        country,
      }}
    />
  );
};

export default OnlineBanking;
